//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/ShipDesign.js";
import "../no/Object.js";
import "../ShipDesign/ShipDesign.ShipSession.js";
let d=[[],[[[],"GASketchEnd",{},0,0],[[],"ResizeGrid",{},0,0],[["part"],"MakeContainerPart",{},1,0],[["sketch"],"CreateSkecthRectangle",{},1,0],[["srPlane"],"CreateWaveLinkPlane",{R_:{dstPlane:"TaggedObject"}},1,0],[["sketch"],"RemoveSketchFromMoldRefSet",{},1,0],[[],"WaveLinkFrameBarToDeckRefPart",{},0,0],[[],"EditRoomCallBack",{},0,0],[[],"RemoveUnusedExpression",{},0,0],[["bShip"],"ReloadMaterialData",{},1,0]],[]];
SPLM.ShipDesign.GeneralArrangementManager = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.ShipDesign.GeneralArrangementManager";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;